import { useEffect } from "react";
import { useLocalFileUpload } from "@/hooks/use-local-file-upload";
import {
  ConvertBaseContextState,
  ConvertBaseSettings,
} from "@/hooks/ai-tool-process/use-convert-base-context-provider";
import { useMediaInputContext } from "@/providers/media-input-provider/media-input-provider";

export const useLocalFileData = () => {
  const {
    handleFileChange: onFileChange,
    uploadedFiles,
    licenseManager,
  } = useMediaInputContext();

  const changeContext = async (file: any) => {
    onFileChange({
      type: "localFile",
      songFile: file,
    });
  };

  const deleteInContext = async () => {
    onFileChange({
      type: "localFile",
      songFile: undefined,
    });
  };

  const {
    fileUrl,
    isDragging,
    localFile,
    localFileName,
    setLocalFile,
    setLocalFileName,
    handleFileChange,
    handleDrop,
    handleDropCancel,
    handleDeleteButtonClick,
    handleDragOver,
    handleDragEnter,
    handleDragLeave,
  } = useLocalFileUpload(changeContext, deleteInContext, licenseManager);

  useEffect(() => {
    setLocalFile(uploadedFiles.localFile?.songFile ?? null);
    setLocalFileName(uploadedFiles.localFile?.songFile?.name ?? "");
  }, [uploadedFiles.localFile]);

  return {
    fileUrl,
    isDragging,
    localFile,
    localFileName,
    handleFileChange,
    handleDeleteButtonClick,
    handleDrop,
    handleDropCancel,
    handleDragOver,
    handleDragEnter,
    handleDragLeave,
  };
};
